export default __webpack_public_path__ + "static/media/Twitter_Black.44f93523.svg";